import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import CopyButton from "@client/components/ui/CopyButton";
import DomUtils from "@client/utils/DomUtils";
import notificationStore from "@client/stores/NotificationStore";

const CopyButtonStyled = styled(CopyButton)`
  background-position-y: 4px;
  margin-left: 4px;
`;
const Wrapper = styled.div`
  cursor: pointer;
  word-break: break-word;

  &:hover ${CopyButtonStyled} {
    opacity: 1;
  }
`;

type Props = {
  value: string | null | undefined;
  onCopy?: (value: string) => void;
  useDangerousHtml?: boolean;
};
@observer
class CopyMultineValue extends React.Component<Props> {
  handleCopy() {
    let { value } = this.props;
    if (!value) {
      return;
    }
    if (this.props.useDangerousHtml) {
      value = value.replace(/<br\s*\/>/g, "\n").replace(/<.*?>/g, "");
    }

    const succesful = DomUtils.copyTextToClipboard(value);
    if (this.props.onCopy) this.props.onCopy(value);

    if (succesful) {
      notificationStore.alert("The message has been copied to clipboard.");
    }
  }

  render() {
    let text: React.ReactNode = this.props.value;
    if (this.props.useDangerousHtml) {
      text = <span dangerouslySetInnerHTML={{ __html: text as string }} />;
    }

    return (
      <Wrapper
        onClick={() => {
          this.handleCopy();
        }}
      >
        {text}
        <CopyButtonStyled />
      </Wrapper>
    );
  }
}

export default CopyMultineValue;
